import { IUsageHistoryListParam } from '@src/type/business'
import instance from '../axios'

export const BusinessUsageHistoryApis = {
  getUsageHistoryGraph: (data: number) => instance.get(`/v1/corporate/usageHistory/graph/${data}`),
  getUsageHistoryList: (data: IUsageHistoryListParam) => instance.post(`/v1/corporate/usageHistory/list`, data),
  getUsageHistoryInfo: (data: string) => instance.get(`/v1/corporate/usageHistory/${data}`),
}
